export const PRESENTATION_DEBUG_REF = '__cortex_presentation_debug_ref__';

export const PRESENTATION_DEBUG_HOOK = '__cortex_presentation_debug_hook__';
